export default __webpack_public_path__ + "static/media/insurance_ln.01ea48fa.svg";